/**
 * OVERRIDE actions/querystringsearch/querystringsearch.js
 * REASON: Do not load on first render if data is already loaded from SSR to avoid flickering.
 * FILE:
 * FILE VERSION: VLT 5.0.1
 * PULL REQUEST:
 * TICKET: https://gitlab.fhnw.ch/webteam/fhnw-webauftritt-2025/-/issues/893
 * DATE: 2025-10-27
 * DEVELOPER: @reebalazs
 *
 * Depending on the nature of the change, if possible or suitable, mark the change with a JSX comment at the beginning and end of the change:
 *
 *   START CUSTOMIZATION
 *   <CUSTOMIZATION>
 *   END CUSTOMIZATION
 */

import { GET_QUERYSTRING_RESULTS } from '@plone/volto/constants/ActionTypes';
import config from '@plone/volto/registry';
// START CUSTOMIZATION
export const QUERYSTRING_CLEAR_SSR = 'QUERYSTRING_CLEAR_SSR';
// END CUSTOMIZATION

/**
 * Get querystring results.
 * @function getQueryStringResults
 * @param {Object} data Data.
 * @returns {Object} Get querystringsearch results action.
 */
export function getQueryStringResults(
  path,
  data,
  subrequest,
  page,
  // START CUSTOMIZATION
  isSSR = false,
  // END CUSTOMIZATION
) {
  const { settings } = config;

  // fixes https://github.com/plone/volto/issues/1059
  let requestData = JSON.parse(JSON.stringify(data));

  if (data?.depth != null) {
    delete requestData.depth;
    requestData.query.forEach((q) => {
      if (q.i === 'path') {
        q.v += '::' + data.depth;
      }
    });
  }

  // fixes https://github.com/plone/volto/issues/2397
  if (requestData?.sort_order !== null) {
    if (typeof requestData.sort_order === 'boolean') {
      requestData.sort_order = requestData.sort_order
        ? 'descending'
        : 'ascending';
    }
  }

  const query = {
    ...requestData,
    ...(!requestData.b_size && {
      b_size: settings.defaultPageSize,
    }),
    ...(page && {
      b_start: requestData.b_size
        ? data.b_size * (page - 1)
        : settings.defaultPageSize * (page - 1),
    }),
    query: requestData?.query,
  };

  return {
    type: GET_QUERYSTRING_RESULTS,
    subrequest,
    // START CUSTOMIZATION
    queryKey: JSON.stringify(query),
    // END CUSTOMIZATION
    request: {
      op: settings.querystringSearchGet ? 'get' : 'post',
      path: `${path}/@querystring-search${
        settings.querystringSearchGet
          ? `?query=${encodeURIComponent(JSON.stringify(query))}`
          : ''
      }`,
      data: settings.querystringSearchGet ? null : query,
    },
    // START CUSTOMIZATION
    isSSR,
    // END CUSTOMIZATION
  };
}

// START CUSTOMIZATION
export const queryStringClearSSR = (subrequest) => ({
  type: QUERYSTRING_CLEAR_SSR,
  subrequest,
});
// END CUSTOMIZATION
